import { handleValueOrFn as origHandleValueOrFn } from './utils/handleValueOrFn';

/**
 * @deprecated - use `handleValueOrFn` from `@clerk/shared/utils` instead
 */
export const handleValueOrFn = origHandleValueOrFn;
